// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".show-past-arrivals[data-v-e728cc48]{width:157px}@media(max-width: 1199.98px){.show-past-arrivals[data-v-e728cc48]{width:179px}}", ""]);
// Exports
module.exports = exports;
